import { connect } from 'react-redux';

import * as React from 'react';
import { IProperty } from '../../../../../data/entities/property';
import { imagesForProperty } from '../../../../../entities/images/selectors';
import { IState } from '../../../../../store/reducer';
import { useDataLoad, useDebouncedCallback } from '../../../../helpers/hooks';
import { buildMapDispatchToProps, Container } from '../../../../helpers/redux';
import { bindFirstArg } from '../../../../helpers/typing';
import { photosDeleting, photosErrors, photosSuccesses, photosUploading } from '../../selectors';
import { deletePhotos, getPhotos, reorderPhotos, uploadPhotos } from './actions';
import { PropertyEditPhotos as Component } from './PropertyEditPhotos';

const mapDispatchToProps = buildMapDispatchToProps({
	getPhotos, deletePhotos, uploadPhotos, reorderPhotos
});

// NOTE: Task-Based Property is currently using this component to provide photos functionality.
// Please check it is OK to modify this there as well.
// `buttonContext` indicates the component is being rendered inside Task-Based property, and will use Merlin's Button
const mapStateToProps = (state: IState, ownProps: { property: IProperty, buttonContext?: 'merlin' | 'portal' }) => {
	const { property, buttonContext } = ownProps;

	const uploading = photosUploading(property.id, state);
	const deleting = photosDeleting(property.id, state);
	const successes = photosSuccesses(property.id, state);
	const errors = photosErrors(property.id, state);

	return {
		property,
		images: imagesForProperty(property.id, state),
		uploading: !!(uploading && uploading.uploading),
		processing: !!(uploading && uploading.processing),
		percent: uploading ? uploading.percent || 0 : null,
		deleting,
		errors,
		successes,
		buttonContext
	};
};

const PropertyEditPhotosContainer: Container<typeof mapStateToProps, typeof mapDispatchToProps> = (props) => {
	const { property, images } = props;

	const loading = useDataLoad(!images, () => props.getPhotos(property.id));

	const boundCallbacks = {
		deletePhotos: bindFirstArg(props.deletePhotos, property.id),
		uploadPhotos: bindFirstArg(props.uploadPhotos, property.id),
		reorderPhotos: useDebouncedCallback(bindFirstArg(props.reorderPhotos, property.id), 500),
	};

	return <Component
		{...props}
		{...boundCallbacks}
		loading={loading}
	/>;
};

export const PropertyEditPhotos = connect(mapStateToProps, mapDispatchToProps)(PropertyEditPhotosContainer);
